@if (product) {
    <div class="product-buy-box">
        @if (showPricing) {
            <div class="price-wrapper">
                <product-selection [productGroup]="productGroup" [product]="product" [isCmsStyling]="true"
                                   (updateProductEvent)="updateProductEvent($event)" [btnClass]="'btn-new add-product-container'"></product-selection>

                <div class="radio-button-group">
                    @if (showAddToAo) {
                        <label class="radio-button">
                            <input type="radio" name="option_{{product.usanaId}}" value="addToAo" class="radio-visible" [(ngModel)]="selectedProductOption">
                            <div class="pull-left margin-right-8">
                                <div class="price-row">
                                    <div>
                                        @if (aoStrikethroughPrice()) {
                                            <span class="featured-retail-price retail-price margin-right-4"
                                                  automation-tag="currentPrice">{{ aoStrikethroughPrice() | usanacurrency | async }}</span>
                                        }
                                        <span class="price-row-price" automation-tag="aoPrice">{{ (hasAutoOrders() ? product.aoPrice.price : product.price.price) | usanacurrency | async }}</span>
                                    </div>
                                    @if (shouldDisplayVolume) {
                                        <div automation-tag="volume" class="price-row-vol">
                                            <span translate="cart.product.recommended.volume"></span>&nbsp;{{product.price.volume}}
                                        </div>
                                    }
                                </div>
                                @if (hasAutoOrders()) {
                                    <div class="price-row-desc" translate="cart.product.subscribe.and.save"></div>
                                } @else if (product.aoPrice?.aoDiscount) {
                                    <div class="price-row-desc" [innerHTML]="subscribeAndSaveMsg"></div>
                                } @else {
                                    <div class="price-row-desc" translate="cart.product.subscribe"></div>
                                }
                            </div>
                        </label>
                    }
                    @if (showAddToCart) {
                        <label class="radio-button">
                            <input type="radio" name="option_{{product.usanaId}}" value="addToCart" class="radio-visible" [(ngModel)]="selectedProductOption">
                            <div class="pull-left margin-right-8">
                                <div class="price-row">
                                    <div>
                                        @if (showRetailStrikethroughByProduct(product)) {
                                            <span class="featured-retail-price retail-price margin-right-4"
                                                  automation-tag="retailPrice">{{ product.retailPrice.price | usanacurrency | async }}</span>
                                        }
                                        <span class="price-row-price" automation-tag="currentPrice">{{ product.price.price | usanacurrency | async }}</span>
                                    </div>
                                    @if (shouldDisplayVolume) {
                                        <div automation-tag="volume" class="price-row-vol">
                                            <span translate="cart.product.recommended.volume"></span>&nbsp;{{product.price.volume}}
                                        </div>
                                    }
                                </div>
                                <div class="price-row-desc" translate="cart.product.one.time.order"></div>
                            </div>
                        </label>
                    }
                </div>

                @if (showPcComparison && isPdp) {
                    <div class="pdp-pc-upsell-link">
                        <a (click)="sendUpsellPromotionClick($event)"
                           translate="cart.product.pc.upsell"
                           [routerLink]="ENROLL_PC_INFO_ROUTE"></a>
                    </div>
                }
            </div>
        }

        <div class="product-ordering">
            @if (product && (showAddToAo || showAddToCart)) {
                <div class="add-product-container">
                    @if (isAoSelected) {
                        <add-ao-dropdown
                            [addProduct]="product"
                            [useUpdatedAoList]="true"
                            [isCmsStyling]="true"
                            [btnClass]="'button button-black add-product-container'"
                            [quantity]="quantity"></add-ao-dropdown>
                    } @else if (isCartSelected) {
                        @if (productQty) {
                            <div class="form-group qty-box">
                                <label for="productQuantity{{product.usanaId}}" translate="cart.product.quantity"></label>
                                <input type="text" id="productQuantity{{product.usanaId}}" class="form-control productQuantityInput"
                                       [(ngModel)]="quantity">
                            </div>
                        }

                        <add-to-cart-button [quantity]="quantity" [addProduct]="product"
                                            analyticsName="productView"
                                            (productAddedEvent)="onProductAdded()"
                                            [buttonClass]="'button-black add-product-container'">
                            <i class="fa-regular fa-cart-shopping margin-right-4" aria-hidden="true"></i>
                            <span translate="cart.product.addtocart"></span>
                        </add-to-cart-button>
                    }
                </div>
            }
            @if (isPdp) {
                @if (displayUrlShareables) {
                    <div class="page-section">
                        <div class="social-share">
                            <addShareList [addProduct]="product" [newButton]="true"
                                          [btnClass]="'btn-new add-product-container'"
                                          [location]="'product'"></addShareList>
                            <copy-short-url
                                class="share-list-url"
                                [newButton]="true"
                                [buttonClass]="'btn-new add-product-container'"
                                [shareOptions]="shareOptions"></copy-short-url>
                        </div>
                    </div>
                }
                <div class="product-ordering-messages">
                    <fs-not-eligible [product]="product"></fs-not-eligible>

                    @if (shouldDisplayImportTax && !!importTaxDisplay) {
                        <div class="product-tax">{{importTaxDisplay}}</div>
                    }
                </div>
            }
        </div>
    </div>
}
